import ProviderAPI from '../../APIs/ProviderAPI/providerAPI'

export const ProviderActions = {
    state: {
        hasAcuAccessData: null,
        markAcuProcDoneData: null,
        verifyAcuApprovalData: null,
        getDiagnosisListData: null,
        generateApprovalDiagnosticprocedureData: null,
        downloadLedgerData: null,
        getLedgerControlsData: null,
        generateReportData: null,
        getLinkedProvidersData: null,
        membEmail: null,
        membDetails: null,
        providerAffiDoctors: null,
        recoverPass: null,
        providerForgotPassword: null,
        downloadAuthorization: null,
        providerHistory: null,
        changePass: null,
        accountCred: null,
        membHospClinAll: null,
        approvalConsultation: null,
        isPatienEligible: null,
        newProviderData: null,
        docInfo: null,
        docAffiliates: null,
        hasProcedureAccessData: null
    },
    actions: {
        async hasProcedureAccess({ commit }, data) {
            await ProviderAPI.hasProcedureAccess(data)
                .then(res=>{
                    commit('HAS_PROCEDURE_ACCESS', res && res.data)
                })
                .catch(error=>{
                    commit('HAS_PROCEDURE_ACCESS', error)
                })
        },
        async hasAcuAccess({ commit }, data) {
            await ProviderAPI.hasAcuAccess(data)
                .then(res=>{
                    commit('HAS_ACU_ACCESS', res && res.data)
                })
                .catch(error=>{
                    commit('HAS_ACU_ACCESS', error)
                })
        },
        async markAcuProcDone({ commit }, data) {
            await ProviderAPI.markAcuProcDone(data)
                .then(res=>{
                    commit('MARK_ACU_PROC_DONE', res && res.data)
                })
                .catch(error=>{
                    commit('MARK_ACU_PROC_DONE', error)
                })
        },
        verifyAcuApproval({ commit }, data) {
            ProviderAPI.verifyAcuApproval(data)
                .then(res=>{
                    commit('VERIFY_ACU_APPROVAL', res && res.data)
                })
                .catch(error=>{
                    commit('VERIFY_ACU_APPROVAL', error)
                })
        },
        getDiagnosisList({ commit }, data) {
            ProviderAPI.getDiagnosisList(data)
                .then(res=>{
                    commit('GET_DIAGNOSIS_LIST', res && res.data)
                })
                .catch(error=>{
                    commit('GET_DIAGNOSIS_LIST', error)
                })
        },
        generateApprovalDiagnosticprocedure({ commit }, data) {
            ProviderAPI.generateApprovalDiagnosticprocedure(data)
                .then(res=>{
                    commit('GENERATE_APPROVAL_DIAGNOSTICPROCEDURE', res && res.data)
                    commit('CHECK_PATIENT', null)
                })
                .catch(error=>{
                    commit('GENERATE_APPROVAL_DIAGNOSTICPROCEDURE', error)
                    commit('CHECK_PATIENT', null)
                })
        },
        downloadLedger({ commit }, data) {
            ProviderAPI.downloadLedger(data)
                .then(res=>{
                    commit('DOWNLOAD_LEDGER', res && res.data)
                })
                .catch(error=>{
                    commit('DOWNLOAD_LEDGER', error)
                })
        },
        getLedgerControls({ commit }, data) {
            ProviderAPI.getLedgerControls(data)
                .then(res=>{
                    commit('GET_LEDGER_CONTROLS', res && res.data)
                })
                .catch(error=>{
                    commit('GET_LEDGER_CONTROLS', error)
                })
        },
        generateReport({ commit }, data) {
            ProviderAPI.generateReport(data)
                .then(res=>{
                    commit('GENERATE_REPORT', res && res.data)
                })
                .catch(error=>{
                    commit('GENERATE_REPORT', error)
                })
        },
        getLinkedProviders({ commit }, data) {
            ProviderAPI.getLinkedProviders(data)
                .then(res=>{
                    commit('LINKED_PROVIDERS', res && res.data)
                })
                .catch(error=>{
                    commit('LINKED_PROVIDERS', error)
                })
        },
        getMembEmail({ commit }, data) {
            ProviderAPI.getMembEmail(data)
                .then(res=>{
                    commit('MEMB_EMAIL', res && res.data)
                })
                .catch(error=>{
                    commit('MEMB_EMAIL', error)
                })
        },
        getMembDetails({ commit }, data) {
            ProviderAPI.getMembDetails(data)
                .then(res=>{
                    commit('MEMB_DETAILS', res && res.data)
                })
                .catch(error=>{
                    commit('MEMB_DETAILS', error)
                })
        },
        getProviderAffiDoctors({ commit }, data) {
            ProviderAPI.getProviderAffiDoctors(data)
                .then(res=>{
                    commit('PROVIDER_AFFI_DOCTORS', res && res.data)
                })
                .catch(error=>{
                    commit('PROVIDER_AFFI_DOCTORS', error.data)
                })
        },
        recoverPassword({ commit }, data) {
            ProviderAPI.recoverPassword(data)
                .then(res=>{
                    commit('RECOVER_PASS', res && res.data ? res.data : [])
                })
                .catch(error=>{
                    commit('RECOVER_PASS', error.data)
                })
        },
        forgotPassword({ commit }, data) {
            ProviderAPI.forgotPassword(data)
                .then(res=>{
                    commit('PROVIDER_FORGOT_PASSWORD', res && res.data ? res.data : [])
                })
                .catch(error=>{
                    commit('PROVIDER_FORGOT_PASSWORD', error.data)
                })
        },
        downloadApproval({ commit }, data) {
            ProviderAPI.downloadApproval(data)
                .then(res=>{
                    commit('DOWNLOAD_AUTHORIZATION', res && res.data ? res.data : [])
                })
                .catch(error=>{
                    commit('DOWNLOAD_AUTHORIZATION', error.data)
                })
        },
        getProviderHistory({ commit }, data) {
            ProviderAPI.getProviderHistory(data)
                .then(res=>{
                    commit('PROVIDER_HISTORY', res && res.data ? res.data : [])
                })
                .catch(error=>{
                    commit('DOC_HISTORY', error.data)
                })
        },
        changePassword({ commit }, data) {
            ProviderAPI.changePassword(data)
                .then(res=>{
                    commit('CHANGE_PASS', res && res.data && res.data ? res.data : [])
                })
                .catch(error=>{
                    commit('CHANGE_PASS', error.data)
                })
        },
        getAccountDetails({ commit }, data) {
            ProviderAPI.getAccountDetails(data)
                .then(res=>{
                    commit('GET_ACCOUNT_DETAILS', res && res.data && res.data.data ? res.data.data : [])
                })
                .catch(error=>{
                    commit('GET_ACCOUNT_DETAILS', error.data)
                })
        },
        getMembHospClinAll({ commit }, data) {
            ProviderAPI.getMembHospClinAll(data)
                .then(res=>{
                    commit('MEMB_HOSP_CLIN_ALL', res && res.data && res.data.data ? res.data.data : [])
                })
                .catch(error=>{
                    commit('MEMB_HOSP_CLIN_ALL', error.data)
                })
        },
        generateApprovalConsultation({ commit }, data) {
            ProviderAPI.generateApprovalConsultation(data)
                .then(res=>{
                    commit('APPROVAL_CONSULTATION', res.data)
                })
                .catch(error=>{

                    commit('APPROVAL_CONSULTATION', error.data)
                })
        },
        checkPatientEligibility({ commit }, data){
            ProviderAPI.checkPatientEligibility(data)
                .then(res=>{
                    commit('CHECK_PATIENT', res.data)
                })
                .catch(error=>{
                    commit('CHECK_PATIENT', error.data)
                })
        },
        createProvider({ commit }, data) {
            ProviderAPI.newProvider(data)
                .then(res=>{
                    commit('NEW_PROVIDER', res.data)
                })
                .catch(error=>{
                    commit('NEW_PROVIDER', error.data)
                })
        },
        getAffiliatesInfo({ commit }, data) {
            ProviderAPI.getAffiliates(data)
                .then(res=>{
                    commit('DOC_AFFILIATES', res.data.data)
                })
                .catch(error=>{
                    commit('DOC_AFFILIATES', error.data.data)
                })
        },
        getProviderInfo({ commit }, data) {
            ProviderAPI.getProviderInfo(data)
                .then(res => {
                    const temp = res.data.data
                    if (temp) {
                        const data = {
                            NAME: temp&&temp.NAME ? temp.NAME : '-',
                            ADDRESS: temp&&temp.ADDRESS ? temp.ADDRESS : '-',
                            STATUS: temp&&temp.STATUS ? temp.STATUS === 'A' ? 'ACTIVE' : '-' : '-',
                            ACCREDITATION_DATE: temp&&temp.ACCREDITATION_DATE ? temp.ACCREDITATION_DATE : '-',
                            TYPE: temp&&temp.TYPE ? temp.TYPE : '-',
                            DECKING: temp&&temp.DECKING ? temp.DECKING : '-'
                        }
                        commit('DOC_INFO', data)
                    }
                })
                .catch(error => {
                    commit('DOC_INFO', error.data)
                })
        }
    },
    mutations: {
        HAS_PROCEDURE_ACCESS(state, hasProcedureAccessData) {
            state.hasProcedureAccessData = hasProcedureAccessData
        },
        HAS_ACU_ACCESS(state, hasAcuAccessData) {
            state.hasAcuAccessData = hasAcuAccessData
        },
        MARK_ACU_PROC_DONE(state, markAcuProcDoneData) {
            state.markAcuProcDoneData = markAcuProcDoneData
        },
        VERIFY_ACU_APPROVAL(state, verifyAcuApprovalData) {
            state.verifyAcuApprovalData = verifyAcuApprovalData
        },
        GET_DIAGNOSIS_LIST(state, getDiagnosisListData) {
            state.getDiagnosisListData = getDiagnosisListData
        },
        GENERATE_APPROVAL_DIAGNOSTICPROCEDURE(state, generateApprovalDiagnosticprocedureData) {
            state.generateApprovalDiagnosticprocedureData = generateApprovalDiagnosticprocedureData
        },
        DOWNLOAD_LEDGER(state, downloadLedgerData) {
            state.downloadLedgerData = downloadLedgerData
        },
        GET_LEDGER_CONTROLS(state, getLedgerControlsData) {
            state.getLedgerControlsData = getLedgerControlsData
        },
        GENERATE_REPORT(state, generateReportData) {
            state.generateReportData = generateReportData
        },
        LINKED_PROVIDERS(state, getLinkedProvidersData) {
            state.getLinkedProvidersData = getLinkedProvidersData
        },
        MEMB_EMAIL(state, membEmail) {
            state.membEmail = membEmail
        },
        MEMB_DETAILS(state, membDetails) {
            state.membDetails = membDetails
        },
        PROVIDER_AFFI_DOCTORS(state, providerAffiDoctors) {
            state.providerAffiDoctors = providerAffiDoctors
        },
        RECOVER_PASS(state, recoverPass) {
            state.recoverPass = recoverPass
        },
        PROVIDER_FORGOT_PASSWORD(state, providerForgotPassword) {
            state.providerForgotPassword = providerForgotPassword
        },
        DOWNLOAD_AUTHORIZATION(state, downloadAuthorization) {
            state.downloadAuthorization = downloadAuthorization
        },
        PROVIDER_HISTORY(state, providerHistory) {
            state.providerHistory = providerHistory
        },
        CHANGE_PASS(state, changePass) {
            state.changePass = changePass
        },
        GET_ACCOUNT_DETAILS(state, accountCred) {
            state.accountCred = accountCred
        },
        MEMB_HOSP_CLIN_ALL(state, membHospClinAll) {
            state.membHospClinAll = membHospClinAll
        },
        APPROVAL_CONSULTATION(state, approvalConsultation) {
            state.approvalConsultation = approvalConsultation
        },
        CHECK_PATIENT(state, isPatienEligible){
            state.isPatienEligible = isPatienEligible
        },
        NEW_PROVIDER(state, newProviderData) {
            state.newProviderData = newProviderData
        },
        DOC_INFO(state, docInfo) {
            state.docInfo = docInfo
        },
        DOC_AFFILIATES(state, docAffiliates) {
            state.docAffiliates = docAffiliates
        }
    },
    getters: {
        hasProcedureAccessData(state) {
            return state.hasProcedureAccessData
        },
        hasAcuAccessData(state) {
            return state.hasAcuAccessData
        },
        markAcuProcDoneData(state) {
            return state.markAcuProcDoneData
        },
        verifyAcuApprovalData(state) {
            return state.verifyAcuApprovalData
        },
        getDiagnosisListData(state) {
            return state.getDiagnosisListData
        },
        generateApprovalDiagnosticprocedureData(state) {
            return state.generateApprovalDiagnosticprocedureData
        },
        downloadLedgerData(state) {
            return state.downloadLedgerData
        },
        getLedgerControlsData(state) {
            return state.getLedgerControlsData
        },
        generateReportData(state) {
            return state.generateReportData
        },
        getLinkedProvidersData(state) {
            return state.getLinkedProvidersData
        },
        membEmail(state) {
            return state.membEmail
        },
        membDetails(state) {
            return state.membDetails
        },
        providerAffiDoctors(state) {
            return state.providerAffiDoctors
        },
        recoverPass(state) {
            return state.recoverPass
        },
        providerForgotPassword(state) {
            return state.providerForgotPassword
        },
        downloadAuthorization(state) {
            return state.downloadAuthorization
        },
        providerHistory(state) {
            return state.providerHistory
        },
        changePass(state) {
            return state.changePass
        },
        accountCred(state) {
            return state.accountCred
        },
        membHospClinAll(state) {
            return state.membHospClinAll
        },
        approvalConsultation(state) {
            return state.approvalConsultation
        },
        isPatientEligible(state) {
            return state.isPatienEligible
        },
        isSuccessCreated(state) {
            return state.newProviderData
        },
        docInfoData(state) {
            return state.docInfo
        },
        docInfoAffiliates(state) {
            return state.docAffiliates
        }
    }
}
